module.exports = __webpack_public_path__ + "img/vignettes-asso_0005_kisany.3875cfa1.jpg";